import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { I as u, a as d } from "./ic_arrowforward_fill-BQJduMXz.mjs";
import "react";
import { c as n } from "./tw-cn-mXgPecoF.mjs";
import { I as x } from "./icon-button-LzZMa7lf.mjs";
const o = ({
  a11yLabel: a,
  onClick: t,
  icon: l,
  className: s
}) => /* @__PURE__ */ e(
  x,
  {
    "aria-label": a,
    className: n(s, "aspect-auto w-58"),
    icon: l,
    onClick: t,
    size: "small",
    theme: "outlined_basic",
    title: a
  }
), h = (a) => "8".repeat(String(a).length), i = ({ align: a = "left", bold: t = !1, value: l }) => /* @__PURE__ */ e("span", { className: n("min-w-40 flex-1 truncate", a === "right" ? "text-right" : "text-left", t && "font-bold"), children: l }), f = ({
  currentPage: a,
  totalPages: t,
  onClickPrevious: l,
  onClickNext: s,
  className: m
}) => {
  const c = h(t);
  return /* @__PURE__ */ r("div", { className: n(m, "flex items-center justify-center"), children: [
    /* @__PURE__ */ e(
      o,
      {
        a11yLabel: "이전",
        icon: /* @__PURE__ */ e(u, { className: "size-20 text-text-neutral-main" }),
        onClick: l
      }
    ),
    /* @__PURE__ */ r("div", { className: "mx-4 flex min-w-68 max-w-158 flex-col items-center justify-center tabular-nums typography-subtitle-16-regular", children: [
      /* @__PURE__ */ r("div", { className: "flex w-full text-text-neutral-main", children: [
        /* @__PURE__ */ e(i, { align: "right", bold: !0, value: a }),
        /* @__PURE__ */ e("span", { className: "mx-4", children: "/" }),
        /* @__PURE__ */ e(i, { value: t })
      ] }),
      /* @__PURE__ */ r("div", { "aria-hidden": "true", className: "h-0 overflow-hidden whitespace-nowrap", children: [
        /* @__PURE__ */ e(i, { align: "right", bold: !0, value: c }),
        /* @__PURE__ */ e("span", { className: "mx-4", children: "/" }),
        /* @__PURE__ */ e(i, { value: c })
      ] })
    ] }),
    /* @__PURE__ */ e(
      o,
      {
        a11yLabel: "다음",
        icon: /* @__PURE__ */ e(d, { className: "size-20 text-text-neutral-main" }),
        onClick: s
      }
    )
  ] });
};
f.displayName = "NDS.PageController";
export {
  f as P
};
